// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AiFactoryMotifRouteImport } from './routes/ai-factory-motif'
import { Route as BrandRouteImport } from './routes/brand'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as EmbeddingSpaceRouteImport } from './routes/embedding-space'
import { Route as LawsRouteImport } from './routes/laws'
import { Route as LlmVisualizationRouteImport } from './routes/llm-visualization'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RelationshipGraphRouteImport } from './routes/relationship-graph'
import { Route as ResumeRouteImport } from './routes/resume'
import { Route as SpaShellRouteImport } from './routes/spa-shell'
import { Route as WritingIndexRouteImport } from './routes/writing.index'
import { Route as WritingSlugRouteImport } from './routes/writing.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AiFactoryMotifRoute = AiFactoryMotifRouteImport.update({
            id: '/ai-factory-motif',path: '/ai-factory-motif',getParentRoute: () => rootRouteImport
          })
const BrandRoute = BrandRouteImport.update({
            id: '/brand',path: '/brand',getParentRoute: () => rootRouteImport
          })
const DesignSystemRoute = DesignSystemRouteImport.update({
            id: '/design-system',path: '/design-system',getParentRoute: () => rootRouteImport
          })
const EmbeddingSpaceRoute = EmbeddingSpaceRouteImport.update({
            id: '/embedding-space',path: '/embedding-space',getParentRoute: () => rootRouteImport
          })
const LawsRoute = LawsRouteImport.update({
            id: '/laws',path: '/laws',getParentRoute: () => rootRouteImport
          })
const LlmVisualizationRoute = LlmVisualizationRouteImport.update({
            id: '/llm-visualization',path: '/llm-visualization',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const RelationshipGraphRoute = RelationshipGraphRouteImport.update({
            id: '/relationship-graph',path: '/relationship-graph',getParentRoute: () => rootRouteImport
          })
const ResumeRoute = ResumeRouteImport.update({
            id: '/resume',path: '/resume',getParentRoute: () => rootRouteImport
          })
const SpaShellRoute = SpaShellRouteImport.update({
            id: '/spa-shell',path: '/spa-shell',getParentRoute: () => rootRouteImport
          })
const WritingIndexRoute = WritingIndexRouteImport.update({
            id: '/writing/',path: '/writing/',getParentRoute: () => rootRouteImport
          })
const WritingSlugRoute = WritingSlugRouteImport.update({
            id: '/writing/$slug',path: '/writing/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AiFactoryMotifRoute: AiFactoryMotifRoute,BrandRoute: BrandRoute,DesignSystemRoute: DesignSystemRoute,EmbeddingSpaceRoute: EmbeddingSpaceRoute,LawsRoute: LawsRoute,LlmVisualizationRoute: LlmVisualizationRoute,LoginRoute: LoginRoute,RelationshipGraphRoute: RelationshipGraphRoute,ResumeRoute: ResumeRoute,SpaShellRoute: SpaShellRoute,WritingSlugRoute: WritingSlugRoute,WritingIndexRoute: WritingIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)